angular.module("UI8.components").component("promoModal", {
  template: `<div class="modal modal--promo">
      <button class="modal__close" ng-click="$ctrl.closeModal()" ui8-toggle-class="promo-modal" ui8-track-event="Close Promo Modal"></button>
      <div class="modal__container">
        <div class="modal__head">
          <h1 class="modal__title">Exclusive Offer</h1>
          <p class="modal__subtitle">Get full access to the entire library for $12 a month with fresh releases added daily. This is a one-time offer for invited users only.</p>
        </div>
        <div class="pass pass--promo">
          <div class="pass__list">
            <div class="pass__item"></div>
            <div class="pass__item" ng-click="$ctrl.addToCart()">
              <div class="pass__type">All Access Exclusive</div>
              <div class="pass__price">
                <div class="pass__price-value">
                  {{ $ctrl.exclusive.price | ui8Currency }}
                </div>
                <div class="pass__price-details">
                  <div class="pass__price-discount">
                    <span></span>
                    <span>75% OFF</span>
                  </div>
                  <div class="pass__price-label">Paid monthly</div>
                </div>
              </div>
              <div class="pass__btn">Unlock All Access Exclusive</div>
              <ul class="pass__details">
                <li>{{ $ctrl.exclusive.daily_download_allowance }} downloads per day</li>
                <li>Full library access</li>
                <li>Daily new products</li>
                <li>Maximum savings</li>
              </ul>
            </div>
            <div class="pass__item"></div>
          </div>
        </div>
        <div class="modal__hint">
          <p>Your invite-only rate stays locked in until you cancel.</p>
          <p>Regular price is <span>$49.00</span> a month.</p>
        </div>
      </div>
      <div class="modal__backdrop" ng-click="$ctrl.closeModal()" ui8-toggle-class="promo-modal" ui8-track-event="Close Promo Modal"></div>
    </div>`,

  controller: function (CartService) {
    // console.log("promoModal");
    const ctrl = this;

    ctrl.$onInit = function () {
      // console.log("promoModal init");
      if (!ctrl.exclusive) ctrl.exclusive = UI8.exclusive;

      const searchParams = new URLSearchParams(window.location.search);
      ctrl.paramOffer = searchParams.get("offer");
      ctrl.paramForce = searchParams.get("force");

      const isUserClosedModal = window.localStorage.getItem(
        "user-closed-promo-modal"
      );

      if ((!isUserClosedModal && ctrl.paramOffer) || ctrl.paramForce) {
        document.body.classList.add("promo-modal");
      }
    };

    function closeModal(userClosed = true) {
      window.localStorage.setItem("user-closed-promo-modal", "true");
      document.body.classList.remove("promo-modal");

      if (userClosed) {
        window.dataLayer.push({
          event:
            ctrl.paramOffer === "purchase_list"
              ? "click_close_offer_purchase_list"
              : "click_close_offer_freebie_list",
        });
      }
    }

    ctrl.closeModal = function () {
      closeModal();
    };

    ctrl.addToCart = function () {
      console.log("addToCart", ctrl.exclusive._id);
      CartService.addPassToCart(ctrl.exclusive._id, 1).then(function () {
        setTimeout(function () {
          const groupCart = $(".header__cell--cart"),
            groupNext = groupCart.find(".payup__sidebar .payup__btn"),
            groupLayout = groupCart.find(".payup__layout"),
            groupBack = groupCart.find(".payup__back");

          groupNext.on("click", function () {
            groupLayout.addClass("step-checkout");
          });

          groupBack.on("click", function () {
            groupLayout.removeClass("step-checkout");
          });
        }, 10);

        closeModal(false);
      });
    };
  },

  bindings: {
    exclusive: "<?",
  },
});
